import { useRouteMatch } from 'react-router-dom';
import { Form } from 'antd';
import { FormattedMessage } from 'react-intl';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import CompanyCustomTermsForm from '@/components/Companies/CompanyCustomTermsForm';
import { useCompanyFormContext } from '@/components/Companies/CompaniesFormProvider';
import { useEffect } from 'react';
import { CompanyTerms } from '@/core/domain/enterprise/Companies/Companies.types';
import CompanyFooter from '@/components/Companies/CompanyFooter';
import { useUpdateBreadcrumbParam } from '@/contexts/BreadcrumbContextProvider';

const CompanyCustomTermsPage = ({ route }: PageProps) => {
  const { companyId } = useRouteMatch<{ companyId: string }>().params;
  const [form] = Form.useForm<CompanyTerms>();
  const { handleSubmit, disabled, customTermsData, isLoading, company } =
    useCompanyFormContext();
  useUpdateBreadcrumbParam(':companyId', company?.name);

  useEffect(() => {
    if (customTermsData) {
      form.setFieldsValue(customTermsData);
    }
  }, [customTermsData]);

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={route.parent}
      baseKey={companyId}
      basePath={`/app/registry/companies/${companyId}`}
      extra={
        <SaveButton
          block
          disabled={disabled || isLoading}
          loading={isLoading}
          type="primary"
          onClick={handleSubmit}
        >
          <FormattedMessage id="commons.entity.save" />
        </SaveButton>
      }
    >
      <CompanyCustomTermsForm form={form} />

      <CompanyFooter disabled={disabled} />
    </DefaultRouteTabs>
  );
};

export default CompanyCustomTermsPage;
